'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:storage:removeItem');
}

var _invoke = require('../invoke');

/**
 * 客户端存储／删
 *
 * 客户端调用是异步的，不保证接下去调用 `hbnb.storage.getItem` 能立刻获取最新值
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof storage
 * @static
 * @name removeItem
 * @return {Undefined}
 * @example
 *  hbnb.storage.removeItem('key');
 */
module.exports = function(key) {
    if (process.env.NODE_ENV !== 'production') {
        debug('key is %s', key);
    }

    _invoke('storage', 'remove_item', {
        key: key
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/storage/remove-item.js
// module id = 617
// module chunks = 0